export type DetectedOS = 'iOS' | 'Mac OS' | 'Android' | 'Windows' | 'Linux' | undefined;

export const detectMobileOS = (): DetectedOS => {
  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(ua)) return 'iOS';
  if (/Macintosh|Mac OS X/.test(ua)) return 'Mac OS';
  if (/Android/.test(ua)) return 'Android';
  if (/Windows/.test(ua)) return 'Windows';
  if (/Linux/.test(ua)) return 'Linux';

  return undefined;
};
